import { useMutation } from 'react-query';
import { forgotPassword, setNewPassword } from 'api/forgotPassword';

export const useForgotPassword = () => {

  return useMutation((params: {registeredEmail: string, }) => forgotPassword(params));

}

export const useSetNewPassword = () => {

  return useMutation((params: {newPassword: string, token: string}) => setNewPassword(params));

}

